import React from "react";
import { Button } from "primereact/button";
import localeText from "../../../../../locale";

const getDisplayTitle = (account) => {
  if (account.type === "PAYPAL") return account.paypalEmail || "PayPal";
  return account.bankname || account.iban || localeText("bank");
};

const BankAccountCard = ({ account, onEdit, onDelete }) => {
  const title = getDisplayTitle(account);
  const isPayPal = account.type === "PAYPAL";

  return (
    <div
      className="card border-round-xl p-3 flex flex-column justify-content-between"
      style={{ border: "1px solid var(--theme-border, #EBEBEB)", minHeight: "180px" }}
    >
      <div className="flex align-items-start justify-content-between mb-3">
        <span
          className="font-semibold text-lg"
          style={{
            color: "var(--theme-text, #171717)",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
          }}
        >
          {title}
        </span>
        {account.isDefault && (
          <span
            className="flex align-items-center gap-1 px-2 py-1 border-round text-xs font-medium"
            style={{
              backgroundColor: "color-mix(in srgb, var(--theme-secondary) 10%, transparent)",
              color: "var(--theme-secondary, #2E7D32)",
            }}
          >
            <i className="pi pi-check" />
            {localeText("principal")}
          </span>
        )}
      </div>
      <div
        className=""
        style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}
      >
        <span className="text-xs font-medium text-500 block mb-1">
          {isPayPal ? "PayPal" : localeText("bank")}
        </span>
        {isPayPal ? (
          <span className="text-sm" style={{ color: "var(--theme-text-muted, #5C5C5C)" }}>
            {localeText("email")}: {account.paypalEmail}
          </span>
        ) : (
          <span className="text-sm" style={{ color: "var(--theme-text-muted, #5C5C5C)" }}>
            IBAN {account.iban}
          </span>
        )}
      </div>
      <hr className="my-3" style={{ borderColor: "var(--theme-border, #EBEBEB)" }} />
      <div className="flex gap-2 mt-auto justify-content-between">
        <Button
          label={localeText("configure")}
          className="p-button-text text-sm border-round-md p-no-outline font-medium"
          style={{
            backgroundColor: "color-mix(in srgb, var(--theme-secondary) 10%, transparent)",
            color: "var(--theme-secondary, #272360)",
          }}
          onClick={() => onEdit?.(account)}
        />
        <Button
          icon="pi pi-trash"
          className="p-button-text p-no-outline border-round-md delete-bank-account-button"
          style={{
            backgroundColor: "color-mix(in srgb, #FB3748 10%, transparent)",
            color: "var(--theme-error, #FB3748)",
          }}
          onClick={() => onDelete?.(account)}
          aria-label={localeText("delete")}
        />
      </div>
    </div>
  );
};

export default React.memo(BankAccountCard);
